export default {
  newMortgage: {
    cta: "Suivant",
    step_1: {
      title:
        "Est-ce que vous planifier vivre dans cette propriété ou est-ce un investissement?",
      subtitle:
        "Les prêteurs offrent habituellement un rabais pour les maisons occupées par leur propriétaire.",
      option_1: "Je vais y vivre",
      option_2: "C’est un investissement"
    },
    step_2: {
      title: "Qu’est-ce qui est le plus important pour vous?",
      option_1: "Découvrir combien je peux emprunter",
      option_2: "Comparer les taux",
      option_3: "Recevoir des conseils d’expert",
      option_4: "Get the best mortgage as soon as possible"
    },
    step_3: {
      title: "Combien planifier vous dépenser pour votre propriété?"
    },
    step_4: {
      title: "Quel est le statut de votre démarche d’achat?",
      option_1: "J’ai signé une offre d’achat",
      option_2: "J’ai trouvé la propriété parfaite",
      option_3: "Je recherche activement",
      option_4: "Je ne cherche pas encore"
    },
    step_5: {
      title: "Finalement, où pouvons-nous envoyer vos taux?",
      placeholder_name: "Nom complet",
      placeholder_email: "E-mail",
      placeholder_areacode: "Code régional",
      placeholder_number: "No de téléphone",
      cta: "Comparer mes taux",
      consultedAlreadyYes: "Oui",
      consultedAlreadyNo: "Non",
      consultedType1: "Autre prêteur hypothécaire inversé",
      consultedType2: "Famille",
      consultedType3: "Gestionnaire de fortune",
      consultedType4: "Agence Bancaire",
      consultedType5: "Courtier",
      consultedType6: "Autre",
      placeholder_consultedTypeOther: "Spécifiez"
    },
    policy:
      "En accédant à la prochaine étape, vous acceptez nos  <a href='/condition-utilisation'>conditions d’utilisations</a> ainsi que notre <a href='/Politique-de-confidentialite'>politique de confidentialité</a>.",
    loaderText: "RECHERCHE DES MEILLEURS TAUX PARMI 2,026 PRODUITS...",
    calculator: {
      cta: "CONTINUER"
    }
  }
}



// WEBPACK FOOTER //
// ./src/i18n/translations/fr/new-mortgage.js